module.exports = __webpack_public_path__ + "img/title.d9b87fcc.png";